import ButtonBase from './ButtonBase';
export const Button = {
  Button_1: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_2: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_3: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_4: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_5: ({ item }) => {
    return <ButtonBase item={item} imageWidth={50}></ButtonBase>;
  },
  Button_6: ({ item }) => {
    return <ButtonBase item={item} imageWidth={50}></ButtonBase>;
  },
  Button_7: ({ item }) => {
    return <ButtonBase item={item} imageWidth={30}></ButtonBase>;
  },
  Button_8: ({ item }) => {
    return <ButtonBase item={item} imageWidth={30}></ButtonBase>;
  },
  Button_9: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_10: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
  Button_Yenir: ({ item }) => {
    return <ButtonBase item={item} imageWidth={100}></ButtonBase>;
  },
};
